(() => {
  const safeLink = (value, base) => { try { const u = new URL(value, base); return ['https:', 'http:'].includes(u.protocol) ? u.href : ''; } catch { return ''; } };
  const init = (root = document) => {
    root.querySelectorAll('.sv-request').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const form = section.querySelector('form');
      const t = JSON.parse(section.querySelector('[data-strings]').textContent);
      const status = section.querySelector('[data-status]');
      const review = section.querySelector('[data-review]');
      const button = form.querySelector('[type=submit]');
      const paymentNote = section.querySelector('[data-payment-note]');
      const steps = Array.from(form.querySelectorAll('[data-form-step]'));
      const progress = form.querySelector('[data-progress]');
      const back = form.querySelector('[data-step-back]');
      const next = form.querySelector('[data-step-next]');
      let step = 0;
      const showStep = (index, focus = true) => {
        step = index;
        steps.forEach((el, i) => el.hidden = i !== step);
        progress.textContent = t.step_label + ' ' + (step + 1) + ' / ' + steps.length;
        back.hidden = step === 0;
        next.hidden = step === steps.length - 1;
        button.hidden = step !== steps.length - 1;
        review.hidden = true;
        if (focus) { steps[step].setAttribute('tabindex','-1'); steps[step].focus({preventScroll:true}); }
      };
      const advanceStep = () => {
        const invalid = Array.from(steps[step].querySelectorAll('input,select,textarea')).find(el => !el.disabled && !el.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        showStep(Math.min(step + 1, steps.length - 1));
      };
      if (steps.length) {
        form.noValidate = true;
        progress.hidden = false;
        form.querySelector('[data-step-actions]').hidden = false;
        next.addEventListener('click', advanceStep);
        back.addEventListener('click', () => showStep(Math.max(0, step - 1)));
        showStep(0, false);
      }
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'cs', {style:'currency',currency:'CZK',maximumFractionDigits:0}).format(amount);
      const pairsIn = cart => cart.items.reduce((sum, item) => sum + (/sneaker|shoe|tenisk|obuv|jordan|dunk|air max|yeezy|new balance/i.test((item.product_type || '') + ' ' + item.product_title) ? Number(item.quantity) : 0), 0);
      const depositLine = pairs => t.deposit_total + ': ' + money(pairs * 500) + ' (' + pairs + ' × 500 Kč)';
      let noteRevision = 0;
      const toggle = async () => {
        const cod = form.elements.payment.value === 'cod';
        const pickup = cod && form.elements.delivery.value === 'pickup';
        section.querySelector('[data-cod-delivery]').hidden = !cod;
        form.querySelectorAll('[name=delivery]').forEach(el => el.disabled = !cod);
        section.querySelector('[data-direct]').hidden = cod;
        section.querySelector('[data-address]').hidden = pickup;
        section.querySelectorAll('[data-address] input').forEach(el => { el.disabled = pickup; el.required = !pickup; });
        section.querySelector('[data-pickup]').hidden = !pickup;
        form.elements.point.disabled = !pickup;
        form.elements.point.required = pickup;
        paymentNote.textContent = cod ? t.deposit : t.advance;
        const revision = ++noteRevision;
        if (cod) {
          try {
            let pairs = Math.max(1, Number(form.elements.quantity?.value) || 1);
            if (section.dataset.mode === 'cart') {
              const response = await fetch(section.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},credentials:'same-origin'});
              if (!response.ok) return;
              pairs = pairsIn(await response.json());
            }
            if (revision === noteRevision) paymentNote.textContent = t.deposit + (pairs ? ' ' + depositLine(pairs) : '');
          } catch {}
        }
      };
      form.addEventListener('change', toggle);
      form.addEventListener('input', event => { review.hidden = true; status.textContent = ''; if (event.target === form.elements.quantity && section.dataset.mode !== 'cart') toggle(); });
      toggle();
      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (steps.length && step < steps.length - 1) { advanceStep(); return; }
        const invalid = Array.from(form.elements).find(el => el.willValidate && !el.checkValidity());
        if (invalid) { const index = steps.findIndex(el => el.contains(invalid)); if (index >= 0) showStep(index); invalid.reportValidity(); return; }
        const d = new FormData(form);
        const v = key => String(d.get(key) || '').trim();
        if (!v('fullname') || !v('phone') || (section.dataset.mode === 'custom' && (!v('model') || !v('size')))) { form.reportValidity(); status.textContent = t.contact + ': ' + t.fullname + ', ' + t.phone; return; }
        button.disabled = true;
        status.textContent = t.loading;
        review.hidden = true;
        try {
          const lines = ['SOLAVE EU', '', t.items + ':'];
          let pairs = 0;
          if (section.dataset.mode === 'cart') {
            const response = await fetch(section.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},credentials:'same-origin'});
            if (!response.ok) throw new Error(t.error);
            const cart = await response.json();
            if (!Array.isArray(cart.items) || !cart.items.length) throw new Error(t.empty_error);
            pairs = pairsIn(cart);
            cart.items.forEach((item, i) => {
              lines.push((i+1) + '. ' + item.product_title, t.size + ': ' + (item.variant_title || '—'), t.quantity + ': ' + item.quantity);
              const product = safeLink(item.url, section.dataset.shopUrl);
              const photo = safeLink(item.featured_image?.url || item.image || '', section.dataset.shopUrl);
              if (product) lines.push(t.product_link + ': ' + product);
              if ((item.featured_image?.url || item.image) && photo) lines.push(t.image_link + ': ' + photo);
              lines.push('');
            });
            lines.push(t.subtotal + ': ' + new Intl.NumberFormat(document.documentElement.lang || 'cs', {style:'currency',currency:cart.currency}).format(cart.total_price / 100), t.shipping_free, '');
          } else {
            pairs = Number(v('quantity'));
            lines.push(v('model'), t.size + ': ' + v('size'), t.quantity + ': ' + v('quantity'));
            if (v('photo')) { const link = safeLink(v('photo')); if (!link) throw new Error(t.photo); lines.push(t.image_link + ': ' + link); }
            lines.push('');
          }
          const cod = v('payment') === 'cod';
          const pickup = cod && v('delivery') === 'pickup';
          lines.push(t.fullname + ': ' + v('fullname'), t.email + ': ' + v('email'), t.phone + ': ' + v('phone'), t.country + ': ' + form.elements.country.selectedOptions[0].textContent, t.payment + ': ' + (cod ? t.cod : t.prepaid), t.delivery + ': ' + (cod ? pickup ? t.pickup : t.home : t.direct));
          if (pickup) lines.push(t.point + ': ' + v('point'));
          else lines.push(v('street'), v('zip') + ' ' + v('city'));
          if (v('note')) lines.push(t.note + ': ' + v('note'));
          if (cod && pairs > 0) lines.push(depositLine(pairs));
          const message = lines.join('\n');
          section.querySelector('[data-message]').value = message;
          section.querySelector('[data-whatsapp]').href = 'https://wa.me/' + section.dataset.phone + '?text=' + encodeURIComponent(message);
          review.hidden = false;
          status.textContent = t.not_sent;
          review.focus({preventScroll:true});
          review.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
        } catch(error) { status.textContent = error.message || t.error; }
        finally { button.disabled = false; }
      });
      section.querySelector('[data-copy]').addEventListener('click', async () => {
        const el = section.querySelector('[data-message]');
        try { await navigator.clipboard.writeText(el.value); section.querySelector('[data-copy-status]').textContent = t.copied; }
        catch { el.focus(); el.select(); section.querySelector('[data-copy-status]').textContent = t.copy_error; }
      });
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting) {entry.target.classList.add('sv-visible');observer.unobserve(entry.target);} }),{threshold:0.08});
      root.querySelectorAll('.sv-reveal, .sv-steps article, .sv-product').forEach(el=>observer.observe(el));
    }
  };
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();



